<script>
import * as m from '@app/paraglide/messages.js';
import { showModal } from '@app/store/modalStore.svelte.js';
</script>

<li class="nav-item" title={m.toolbar_secondary_import_file_title()}>
    <a
        class="nav-link"
        href="#!/"
        role="button"
        aria-label={m.toolbar_secondary_import_file_aria_label()}
        onclick={() => showModal('fileImport')}
    ><i class="bi bi-download"></i></a>
</li>
